import { useChapterSettings } from '@app/components/chapters/hooks';
import ChapterParagraphComments from '@app/domains/chapter/components/ChapterParagraphComments';
import { useCommentsUrlHash } from '@app/domains/chapter/hooks/useCommentsUrlHash';
import { type ReactNode, useCallback, useEffect, useRef, useState } from 'react';

export type ChapterParagraphProps = {
    children?: ReactNode;
    className?: string;
};

export default function ChapterParagraph({ children, className, ...rest }: ChapterParagraphProps) {
    const paraRef = useRef<HTMLParagraphElement>(null);

    const [settings] = useChapterSettings();
    const paragraphId = rest['data-uid'];

    const { showHashCommentInThisPara } = useCommentsUrlHash(paragraphId);

    const [open, setOpen] = useState(false);
    const setCommentsOpen = useCallback((open: boolean) => {
        setOpen(open);
    }, []);

    useEffect(() => {
        /*if (paraRef.current && openComments) {
            animateScrollTo(paraRef.current, {
                maxDuration: 500,
                verticalOffset: -200,
            });
        }*/
        if (showHashCommentInThisPara) {
            setOpen(true);
        }
    }, [showHashCommentInThisPara]);

    return (
        <p ref={paraRef} className={className} {...rest}>
            {children}
            {!!paragraphId && (settings.paragraphComments || open) && (
                <ChapterParagraphComments
                    paragraphId={paragraphId}
                    showBadge={settings.paragraphComments}
                    setCommentsOpen={setCommentsOpen}
                    openComments={open}
                />
            )}
        </p>
    );
}
